import { render } from "./LocationListComponent.vue?vue&type=template&id=badeeb36"
import script from "./LocationListComponent.vue?vue&type=script&lang=js"
export * from "./LocationListComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__